<template>
  <div class="registration-page">
    <div class="registration-page-container">
      <div class="section">
        <div class="section-header"><h3>부가서비스</h3></div>
        <div class="section-body">
          <dl
                  class="field-group"
                  v-if="
              registration.sppsProdNmCntn !== '' ||
                registration.rqstSppsNmCntn !== ''
            "
          >
            <dt class="field-label">
              부가서비스
            </dt>
            <dd class="field-control">
              <div class="field-control-sub">
                <p class="data-text" v-if="registration.sppsProdNmCntn !== ''">
                  대리점 추천 부가 서비스 : {{ registration.sppsProdNmCntn }}
                </p>
                <p class="data-text" v-if="registration.rqstSppsNmCntn !== ''">
                  고객님이 선택하신 부가 서비스 :
                  {{ registration.rqstSppsNmCntn }}
                </p>
                <a
                        id="btnAddService"
                        @click="btnAddService"
                        title="새창열림"
                        target="_blank"
                        class="link-detail"
                        tabindex="0"
                >상세보기</a
                >
              </div>
            </dd>
          </dl>

          <dl class="field-group">
            <dt class="field-label">
              휴대폰보험
            </dt>
            <dd class="field-control">
              <div class="field-control-sub">
                <p class="data-text">{{ registration.lssInsrDivsNm }}</p>
                <a
                        id="popLssInsr"
                        @click="popLssInsr('1')"
                        title="새창열림"
                        target="_blank"
                        class="link-detail"
                        tabindex="0"
                >상세보기</a
                >
              </div>
            </dd>
          </dl>
          <dl class="field-group" v-show="registration.onetAplePncrDivsCd === '01'">
            <dt class="field-label">
              맘대로 폰교체
            </dt>
            <dd class="field-control">
              <div class="field-control-sub">
                <p class="data-text">교체형</p>
                <a
                        id="popLssInsr3"
                        @click="popLssInsr('2')"
                        title="새창열림"
                        target="_blank"
                        class="link-detail"
                        tabindex="0"
                >상세보기</a
                >
              </div>
            </dd>
          </dl>

          <dl v-if="registration.custKdCd === 'A'" class="field-group">
            <dt class="field-label">
              청소년 음란물정보 차단
            </dt>
            <dd class="field-control">
              <div class="field-control-sub">
                <p
                        v-if="registration.adltCntsIsolRqstYn === 'Y'"
                        class="data-text"
                >
                  <span>청소년 음란물정보 차단 동의</span>
                </p>
                <p v-if="registration.nwIsolYn === 'Y'">
                  (필수)네트워크차단(무료) 동의
                </p>
                <p v-if="registration.smatAppUseYn === 'Y'">
                  (선택)자녀폰 지킴이-앱차단(무료) 동의
                </p>
                <p v-if="registration.bukeAppUseYn === 'Y'">
                  (선택)자녀폰 지킴이-앱차단(유료) 동의
                </p>
                <!-- <a
                  id="popTeenager"
                  @click="popTeenager"
                  title="새창열림"
                  target="_blank"
                  class="link-detail"
                  tabindex="0"
                  >상세보기</a
                > -->
              </div>
            </dd>
          </dl>
        </div>
      </div>

      <div class="section" v-if="registration.onsaAplyPlnNm && registration.dcntKdCd === 'DT01'">
        <div class="section-header"><h3>플랜</h3></div>
        <div class="section-body">
          <dl class="field-group">
            <dt class="field-label">
              플랜
            </dt>
            <dd class="field-control">
              <div class="field-control-sub">
                <p class="data-text">{{ planName }}</p>
              </div>
            </dd>
          </dl>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { store } from '@/store'
  export default {
    name: 'AdditionalServicesSectionView',

    props: {
      registrationProps: Object
    },

    data() {
      return {
        registration: {
          planName: ''
        }
      }
    },

    mounted() {
      this.registration = this.registrationProps
      if(this.registration.onsaAplyPlnNm === "Six Plan") {
        this.planName = "식스플랜"
      }
      if(this.registration.onsaAplyPlnNm === "Basic") {
        this.planName = "베이직플랜"
      }
    },

    methods: {
      /**
       * Function    : btnAddService
       * Description : 부가서비스 상세보기
       **/
      btnAddService(e) {
        e.preventDefault()
        window.open(
                'https://www.lguplus.com/plan/addon',
                'PopupWin',
                'width=1100,height=700,top=0,left=0,scrollbars=yes,resizable=yes'
        )
      },

      /**
       * Function    : popLssInsr
       * Description : 휴대폰보험 상세보기
       **/
      popLssInsr(val) {
        
     //   e.preventDefault()
       // alert(this.$store.state.openmarketInfo.onetTxinsrUseYn)
        let url = ''
        if(val=== '2') {// 맘대로폰
          url = 'https://www.lguplus.com/plan/addon/addon-safe/Z020201015'
         
        } else {
          url = 'https://www.lguplus.com/plan/addon/addon-safe/C000180903'
        }

        window.open(
                url,
                'PopupWin',
                'width=1100,height=700,top=0,left=0,scrollbars=yes,resizable=yes'
        )
      },
  
      /**
       * Function    : popTeenager
       * Description : 청소년 음란물정보 차단 상세보기
       **/
      // popTeenager(e) {
      //   //TODO : 청소년 음란물 정보 차단 URL 찾기
      //   e.preventDefault()
      //   window.open(
      //     'http://www.uplus.co.kr/com/main/psmain/PsMbMainService.hpi?mid=222',
      //     'PopupWin',
      //     'width=1100,height=700,top=0,left=0,scrollbars=yes,resizable=yes'
      //   )
      // }
    }
  }
</script>

<style scoped></style>
